import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import FaqCategoryCMSModel from '@/visa-application/models/FaqCategoryCMSModel';

export default class FaqContentSlotCMSModel implements CMSModel {
  id: number;
  title = '';
  sort = '';
  slot_title_translation = '';
  long_desc = '';
  tag = [];
  faq_category: FaqCategoryCMSModel = new FaqCategoryCMSModel();
  dropdown_status?: boolean;
  thump_up?: boolean;
  thump_down?: boolean;
  anchor = '';

  map(obj: any): FaqContentSlotCMSModel {
    this.id = _.get(obj, 'id', 0);
    this.title = _.get(obj, 'title', '');
    this.sort = _.get(obj, 'sort', '');
    this.slot_title_translation = _.get(obj, 'translation[0].slot_title_translation', '');
    this.long_desc = _.get(obj, 'translation[0].long_desc', '');
    this.tag = _.get(obj, 'tag', []);
    this.faq_category.map(_.get(obj, 'faq_category', ''));
    this.dropdown_status = _.get(obj, 'dropdown_status', false);
    this.thump_up = _.get(obj, 'thump_up', false);
    this.thump_down = _.get(obj, 'thump_down', false);
    return this;
  }
}
